export default "__VITE_PUBLIC_ASSET__5f45c29f__"